import * as components from './components'

export default [
  {
    path: '/taskMonitor/:taskId',
    component: components.TaskMonitor,
    name: 'taskMonitor',
    props: true
  },
  {
    path: '/uploadHistory',
    component: components.UploadHistory,
    name: 'uploadHistory',
    props: true
  },
  {
    path: '/institutionUploadHistory',
    component: components.UploadHistory,
    name: 'institutionUploadHistory',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/taskMonitor/routes.js